import {
  LicenceBillingConfig,
  LicenceBillingConfigUpdateRequest,
} from "../types/licenceBillingConfig.definition";
import {
  getLicenceBillingConfig,
  updateLicenceBillingConfig,
} from "../webclients/licenceBillingConfig.client";

export const licenceBillingConfigApi = {
  get: async (): Promise<LicenceBillingConfig> => {
    const response = await getLicenceBillingConfig();
    return response.data;
  },
  update: async (
    data: LicenceBillingConfigUpdateRequest
  ): Promise<LicenceBillingConfig> => {
    const response = await updateLicenceBillingConfig(data);
    return response.data;
  },
};
